export const Direction = {
    HORIZONTAL: 'Direction.HORIZONTAL',
    VERTICAL: 'Direction.VERTICAL',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const directionValues = [...Object.values(Direction)] as const;
export type DirectionType = typeof directionValues[number];

export const DIRECTION_CLASSES: Record<DirectionType, string | null> = {
    [Direction.HORIZONTAL]: null,
    [Direction.VERTICAL]: 'element-group_vertical',
};

export const Indent = {
    NONE: 'Indent.NONE',
    XXS: 'Indent.XXS',
    XS: 'Indent.XS',
    S: 'Indent.S',
    SM: 'Indent.SM',
    M: 'Indent.M',
    L: 'Indent.L',
    XL: 'Indent.XL',
    XLS: 'Indent.XLS',
    XXL: 'Indent.XXL',
    XXXL: 'Indent.XXXL',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const indentValues = [...Object.values(Indent)] as const;
export type IndentType = typeof indentValues[number];

export const INDENT_CLASSES: Record<IndentType, string | null> = {
    [Indent.NONE]: null,
    [Indent.XXS]: 'element-group_xxs',
    [Indent.XS]: 'element-group_xs',
    [Indent.S]: 'element-group_s',
    [Indent.SM]: 'element-group_sm',
    [Indent.M]: 'element-group_m',
    [Indent.L]: 'element-group_l',
    [Indent.XL]: 'element-group_xl',
    [Indent.XLS]: 'element-group_xls',
    [Indent.XXL]: 'element-group_xxl',
    [Indent.XXXL]: 'element-group_xxxl',
};

export const Justify = {
    START: 'Justify.START',
    END: 'Justify.END',
    CENTER: 'Justify.CENTER',
    BETWEEN: 'Justify.BETWEEN',
    AROUND: 'Justify.AROUND',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const justifyValues = [...Object.values(Justify)] as const;
export type JustifyType = typeof justifyValues[number];

export const JUSTIFY_CLASSES: Record<JustifyType, string> = {
    [Justify.START]: 'element-group_start',
    [Justify.END]: 'element-group_end',
    [Justify.CENTER]: 'element-group_center',
    [Justify.BETWEEN]: 'element-group_between',
    [Justify.AROUND]: 'element-group_around',
};

export const Align = {
    STRETCH: 'Align.STRETCH',
    CENTER: 'Align.CENTER',
    START: 'Align.START',
    END: 'Align.END',
    BASELINE: 'Align.BASELINE',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const alignValues = [...Object.values(Align)] as const;
export type AlignType = typeof alignValues[number];

export const ALIGN_CLASSES: Record<AlignType, string> = {
    [Align.STRETCH]: 'element-group_a-stretch',
    [Align.CENTER]: 'element-group_a-center',
    [Align.START]: 'element-group_a-start',
    [Align.END]: 'element-group_a-end',
    [Align.BASELINE]: 'element-group_a-baseline',
};

// Item constants

export const AlignItem = {
    AUTO: 'Align.AUTO',
    STRETCH: 'Align.STRETCH',
    CENTER: 'Align.CENTER',
    START: 'Align.START',
    END: 'Align.END',
    BASELINE: 'Align.BASELINE',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const alignItemValues = [...Object.values(AlignItem)] as const;
export type AlignItemType = typeof alignItemValues[number];

export const ALIGN_ITEM_CLASSES: Record<AlignItemType, string | null> = {
    [AlignItem.AUTO]: null,
    [AlignItem.STRETCH]: 'element-group__item_a-stretch',
    [AlignItem.CENTER]: 'element-group__item_a-center',
    [AlignItem.START]: 'element-group__item_a-start',
    [AlignItem.END]: 'element-group__item_a-end',
    [AlignItem.BASELINE]: 'element-group__item_a-baseline',
};
